/**
 * Single-line location for jobs: explicit summary or structured fields.
 */
export function formatJobLocationLine(job) {
  if (!job) return '';
  const loc = job.location != null ? String(job.location).trim() : '';
  if (loc) return loc;
  const parts = [job.address_line1, job.city, job.state, job.zip_code, job.country]
    .map((v) => (v == null || v === '' ? '' : String(v).trim()))
    .filter(Boolean);
  return parts.join(', ');
}
